export enum Countries {
    GERMANY = 'Deutschland',
    AUSTRIA = 'Österreich',
    LIECHTENSTEIN = 'Liechtenstein',
    SWITZERLAND = 'Schweiz',
};
